import React from 'react';
import ServiceTemplate from './ServiceTemplate';

export default function TrabajoSuficienciaProf() {
  return <ServiceTemplate serviceName="trabajo-de-suficiencia-profesional" />;
}
